import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { Field,Form } from 'react-final-form';

import { Button } from 'components';
import FormInputField from 'components/FormInputField/FormInputField';
import ProgressBar from 'components/ProgressBar/ProgressBar';

import styles from './Step1_Email.module.scss';

const Step1_Email = ({ initialValues, onNext, currentStep, totalSteps }) => {
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const onSubmit = async (values) => {
    if (!values.email) return setErrorMessage("Please enter a valid email.");

    setLoading(true);

    try {
      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}/users/validate-business-email/`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ email: values.email }),
        }
      );

      const data = await res.json();

      if (data.exists) {
        setErrorMessage('This email is already registered. Please use a different email.');
        return;
      }

      // Email is available, clear any previous error and proceed
      setErrorMessage('');
      onNext(values);
    } catch (error) {
      console.error('Error checking email:', error);
      setErrorMessage('Something went wrong. Please try again.');
    }
    finally{
      setLoading(false);
    }
  };

  const required = (value) => (value ? undefined : 'Email is required');

  return (
    <div className={styles.formContainer}>
      <ProgressBar currentStep={currentStep} totalSteps={totalSteps} label="Email information" />
      <Form
        onSubmit={onSubmit}
        initialValues={initialValues}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
             <FormInputField
              name="email"
              label="Email"
              type="email"
              placeholder="example@email.com"
              validate={required}
              required
            />

            {errorMessage && (
              <div style={{ color: 'red', margin: '5px', fontSize: "11px" }}>{errorMessage}</div>
            )}

            <div className={styles.buttonWrapper}>
              <Button type="submit" fetching={loading}>Continue</Button>
            </div>
          </form>
        )}
      />
    </div>
  );
};

Step1_Email.propTypes = {
  initialValues: PropTypes.object,
  onNext: PropTypes.func.isRequired,
};

export default Step1_Email;
